// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","redButton":"Button_redButton__Ln1mb"};